import React from 'react'

/**
 * Standardized section title slot.
 * @param {string} label  - mono eyebrow text (e.g. "IDENTITY")
 * @param {string} num    - section number string (e.g. "01")
 * @param {React.ReactNode} title - main heading content
 * @param {React.ReactNode} sub   - optional sub-copy
 */
export function SectionHeading({ label, num, title, sub }) {
    return (
        <header>
            {(label || num) && (
                <div className="section-head">
                    {num && <span className="section-num">{num}</span>}
                    {label && <span className="section-label">{label}</span>}
                </div>
            )}
            {title && (
                <h2 className="display-h2">{title}</h2>
            )}
            {sub && (
                <p className="display-body">{sub}</p>
            )}
        </header>
    )
}
